import { render, staticRenderFns } from "./TabConexao.vue?vue&type=template&id=c1b4dab2&scoped=true"
import script from "./TabConexao.vue?vue&type=script&lang=js"
export * from "./TabConexao.vue?vue&type=script&lang=js"
import style0 from "./TabConexao.vue?vue&type=style&index=0&id=c1b4dab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b4dab2",
  null
  
)

export default component.exports